// src/pages/HomePage.tsx
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Typography, Box, Divider, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import RandomFactCard from '../components/facts/RandomFactCard';
import FactList from '../components/facts/FactList';
import {
  fetchRandomFact,
  fetchRandomFactsList,
} from '../store/slices/factsSlice';
import { AppDispatch, RootState } from '../store';

const HomePage = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { recentFacts, loading } = useSelector(
    (state: RootState) => state.facts
  );
  const userId = useSelector((state: RootState) => state.auth.user?.id);

  useEffect(() => {
    // 獲取每日冷知識
    dispatch(fetchRandomFact(userId));

    // 獲取 5 個隨機冷知識作為"最近冷知識"
    dispatch(fetchRandomFactsList({ count: 3, userId }));
  }, [dispatch, userId]);

  return (
    <Container maxWidth="lg">
      <Box className="py-8">
        <Box className="text-center mb-8">
          <Typography variant="h3" component="h1" gutterBottom>
            每日冷知識
          </Typography>
          <Typography variant="subtitle1" color="textSecondary">
            每天學習一個有趣的冷知識，豐富你的知識寶庫
          </Typography>
        </Box>

        {/* 隨機冷知識卡片 */}
        <Box className="mb-8">
          <RandomFactCard />
        </Box>

        <Divider className="my-8" />

        {/* 投稿引導 */}
        <Box
          className="bg-primary-light text-white p-6 rounded-lg text-center mb-8"
          sx={{ bgcolor: 'primary.light' }}
        >
          <Typography variant="h5" component="h2" gutterBottom>
            你知道有趣的冷知識嗎？
          </Typography>
          <Typography variant="body1" paragraph>
            分享你的冷知識，讓更多人了解這個有趣的世界！
          </Typography>
          <Button
            variant="contained"
            color="secondary"
            component={Link}
            to="/submit"
            size="large"
          >
            投稿冷知識
          </Button>
        </Box>

        {/* 隨機冷知識列表 */}
        <Box className="mt-8">
          <Typography variant="h4" component="h2" gutterBottom>
            探索冷知識
          </Typography>

          <FactList
            facts={recentFacts}
            loading={loading}
            emptyMessage="目前還沒有冷知識，成為第一位投稿者吧！"
          />
        </Box>
      </Box>
    </Container>
  );
};

export default HomePage;
